const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 2.6131
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.117191,0,0,0.116297,0.0150077,0.138018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.874,97.698L30.143,97.698C13.505,97.698 0.017,111.186 0.017,127.824L0.017,385.723C0.017,402.363 13.505,415.849 30.143,415.849L481.874,415.849C498.514,415.849 512,402.363 512,385.723L512,127.824C512,111.186 498.513,97.698 481.874,97.698Z",
    style: {
      fill: "rgb(44,47,136)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.446,392.256L386.013,392.256L386.013,123.5L131.446,123.5L131.446,392.256Z",
    style: {
      fill: "rgb(44,47,136)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.132,130.476L378.564,143.246L131.091,137.569L131.091,136.27L386.132,130.476Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.737,144.901L369.933,157.67L135.466,151.759L134.875,150.813L377.737,144.901Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.987,159.445L361.302,172.095L144.097,166.184L143.506,165.356L368.987,159.445Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.238,173.869L352.789,186.639L153.201,180.727L152.611,179.781L360.238,173.869Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.842,188.293L344.275,201.064L161.833,195.153L161.242,194.207L351.842,188.293Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.093,202.838L335.526,215.489L170.819,209.578L170.229,208.75L343.093,202.838Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.461,217.263L326.895,230.032L180.042,224.121L179.45,223.175L334.461,217.263Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.949,231.688L318.263,244.458L188.673,238.546L188.083,237.6L325.949,231.688Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.436,246.113L309.633,258.883L197.305,252.97L196.713,252.144L317.436,246.113Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.804,260.657L301.119,273.425L206.409,267.396L205.818,266.566L308.804,260.657Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.173,275.083L292.487,287.852L215.396,281.939L214.805,280.994L300.173,275.083Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.542,289.506L283.855,302.277L224.382,296.363L223.79,295.419L291.542,289.506Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.91,304.051L275.343,316.7L233.131,310.789L232.539,309.961L282.91,304.051Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.396,318.474L266.592,331.245L241.762,325.332L241.171,324.389L274.396,318.474Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.411,333.371L257.606,346.615L249.33,339.758L249.095,338.812L265.411,333.371Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,339.286L386.132,339.286L131.091,339.286Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,339.286L386.132,339.286",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,324.859L386.132,324.859L131.091,324.859Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,324.859L386.132,324.859",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,310.434L386.132,310.434L131.091,310.434Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,310.434L386.132,310.434",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,295.891L386.132,295.891L131.091,295.891Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,295.891L386.132,295.891",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,281.466L386.132,281.466L131.091,281.466Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,281.466L386.132,281.466",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,267.04L386.132,267.04L131.091,267.04Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,267.04L386.132,267.04",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,252.616L386.132,252.616L131.091,252.616Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,252.616L386.132,252.616",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,238.073L386.132,238.073L131.091,238.073Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,238.073L386.132,238.073",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,223.647L386.132,223.647L131.091,223.647Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,223.647L386.132,223.647",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,209.222L386.132,209.222L131.091,209.222Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,209.222L386.132,209.222",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,194.798L386.132,194.798L131.091,194.798Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,194.798L386.132,194.798",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,180.254L386.132,180.254L131.091,180.254Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,180.254L386.132,180.254",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,165.83L386.132,165.83L131.091,165.83Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,165.83L386.132,165.83",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,151.404L386.132,151.404L131.091,151.404Z",
    style: {
      fill: "rgb(232,58,141)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.091,151.404L386.132,151.404",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(232,58,141)",
      strokeWidth: "1.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.446,354.892L284.446,382.914L303.483,382.914L305.848,377.594C302.418,377.713 299.936,377.829 296.388,377.829L292.367,377.829L292.367,370.856L292.841,370.856C294.853,370.856 297.097,370.971 299.459,371.09L301.826,365.652C300.643,365.769 300.407,365.769 298.751,365.769C295.797,365.886 295.086,365.886 292.367,365.886L292.367,360.093L293.311,360.093C295.677,360.093 298.749,360.212 302.89,360.329L305.136,354.89L284.446,354.892ZM211.73,354.892L213.74,357.849L202.98,382.914L210.783,382.914L212.558,378.658L223.673,378.658L225.444,382.914L233.604,382.914L221.306,354.892L211.73,354.892ZM221.426,373.573L214.686,373.573L217.997,365.533L221.426,373.573ZM177.322,353.117L169.401,353.117L169.401,382.914L188.555,382.914L190.801,377.594C188.318,377.713 185.126,377.829 181.697,377.829L177.322,377.829L177.322,353.117ZM266.002,356.31C262.928,354.892 260.208,354.301 257.488,354.301C251.458,354.301 247.32,357.613 247.32,362.341C247.32,365.298 248.62,367.307 252.049,369.554L256.069,372.276C257.962,373.575 258.672,374.52 258.672,375.94C258.672,377.713 257.016,378.777 254.533,378.777C252.404,378.777 251.104,378.186 248.739,376.297L246.611,381.26C250.158,383.155 251.932,383.626 255.007,383.626C261.984,383.626 266.358,380.196 266.358,374.878C266.358,371.802 264.94,369.791 261.393,367.309L257.253,364.353C255.48,363.17 255.007,362.58 255.007,361.634C255.007,360.097 256.19,359.152 258.198,359.152C259.973,359.152 261.51,359.743 263.874,361.281L266.002,356.31ZM322.638,354.892L322.638,382.914L330.559,382.914L330.559,360.095L332.215,360.095C335.763,360.095 337.653,361.514 337.653,364.116C337.653,366.836 335.406,368.607 331.859,368.607C331.505,368.607 331.268,368.607 330.677,368.49L340.253,382.915L349.002,382.915L341.079,371.329C344.51,369.318 345.928,367.072 345.928,363.642C345.928,357.728 341.789,354.891 333.396,354.891L322.638,354.891L322.638,354.892Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaser);
export default __webpack_public_path__ + "static/media/laser.b4de72ed49adc151ff6443c77d62d545.svg";
export { ForwardRef as ReactComponent };